$(document).ready(function () {
	$('.vg-orders .btn-order-info').click(function () {
		let $modal =  $("#modal-account-orders");

		let $content = $modal.find('.content');
		let $loader = $modal.find('.vg-account-profile--preloader');

		$content.hide();
		$loader.show();

		$modal.modal('show');

		let route = $(this).attr('data-route');
		let params = {};

		$.get(route, params, function (data) {
			if (data.view) {
				$content.show();
				$loader.hide();

				$content.html(data.view);
			}
		});

		return false;
	});
});
